export default __webpack_public_path__ + "c1ce93d02e507a877ee6e3b41f382e28.svg";